// API istemcisi. Erişim jetonu bellekte + localStorage'da refresh ile;
// 401 gelince BİR KEZ yenilemeyi dener, sonra oturumu düşürür.

const LS_REFRESH = 'orderceo.refresh';
const LS_KIND = 'orderceo.kind'; // staff | platform

let accessToken = null;
let onLogout = () => {};

export function setOnLogout(fn) { onLogout = fn; }
export function session() {
  return { token: accessToken, kind: localStorage.getItem(LS_KIND) };
}
export function storeSession({ accessToken: at, refreshToken, kind }) {
  accessToken = at;
  if (refreshToken) localStorage.setItem(LS_REFRESH, refreshToken);
  if (kind) localStorage.setItem(LS_KIND, kind);
}
export function clearSession() {
  accessToken = null;
  localStorage.removeItem(LS_REFRESH);
  localStorage.removeItem(LS_KIND);
}

async function refresh() {
  const rt = localStorage.getItem(LS_REFRESH);
  if (!rt) return false;
  const res = await fetch('/api/auth/refresh', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ refreshToken: rt }),
  });
  if (!res.ok) return false;
  const data = await res.json();
  storeSession({ accessToken: data.accessToken, refreshToken: data.refreshToken });
  return true;
}

export async function api(path, { method = 'GET', body, retry = true } = {}) {
  const res = await fetch(path, {
    method,
    headers: {
      'content-type': 'application/json',
      ...(accessToken ? { authorization: `Bearer ${accessToken}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401 && retry) {
    if (await refresh()) return api(path, { method, body, retry: false });
    clearSession();
    onLogout();
    throw new ApiError(401, 'unauthorized');
  }

  let data = null;
  try { data = await res.json(); } catch { /* gövdesiz */ }
  if (!res.ok) throw new ApiError(res.status, data?.error || 'error', data);
  return data;
}

export class ApiError extends Error {
  constructor(status, code, body) {
    super(code);
    this.status = status;
    this.code = code;
    this.body = body || {};
  }
}

/** Hata kodunu kullanıcıya gösterilecek Türkçe metne çevirir. */
export function errText(e) {
  if (!(e instanceof ApiError)) return 'Beklenmeyen hata';
  const m = {
    invalid_credentials: 'E-posta ya da şifre hatalı',
    invalid_pin: 'PIN hatalı',
    too_many_requests: 'Çok fazla deneme — biraz sonra tekrar dene',
    choose_restaurant: 'Bu e-posta birden fazla restoranda kayıtlı, birini seç',
    country_not_available: e.body?.detail || 'Bu ülke henüz satışa açık değil',
    feature_not_in_plan: `Bu özellik paketinde yok: ${e.body?.feature || ''}`,
    subscription_required: 'Abonelik gerekiyor',
    plan_limit_reached: `Paket sınırı doldu (${e.body?.used}/${e.body?.limit})`,
    role_escalation_denied: 'Kendinden yüksek rol atayamazsın',
    cannot_modify_higher_role: 'Daha yetkili bir kullanıcıyı değiştiremezsin',
    email_taken: 'Bu e-posta bu restoranda zaten var',
    country_currency_immutable: 'Ülke ve para birimi değiştirilemez (süper admin işi)',
    fiscalization_required: e.body?.detail || 'Bu ülke sertifikalı kasa istiyor',
    amount_must_be_integer_minor: 'Tutar kuruş cinsinden tam sayı olmalı (49.90 → 4990)',
    unknown_feature_keys: `Bilinmeyen özellik: ${(e.body?.unknown || []).join(', ')}`,
    currency_change_requires_confirmation: `Para birimi ${e.body?.from} → ${e.body?.to} değişecek, onay gerekiyor`,
    invalid_vat_rate: 'KDV oranı binde cinsinden tam sayı olmalı (%8.1 → 810)',
    password_too_short: 'Şifre en az 8 karakter olmalı',
  };
  return m[e.code] || `Hata: ${e.code}`;
}

/** Kuruş → gösterim. Panel para hesabı YAPMAZ, yalnız gösterir. */
export function money(minor, currency) {
  if (minor == null) return '—';
  const s = (Math.abs(minor) / 100).toFixed(2);
  return `${minor < 0 ? '-' : ''}${currency ? currency + ' ' : ''}${s}`;
}
